import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { ComponentModal, TitleComponents } from "../common/interfaces";

interface ModalAction {
  closeModal: () => void;
  openModal: (by?: ComponentModal, data?: Record<string, any>) => void;
  setTitle: (by: TitleComponents | string) => void;
  setComponent: (componentName?: ComponentModal, params?: Record<string, any>) => void;
}



export interface IModal {
  title: TitleComponents | string;
  open: boolean;
  component: ComponentModal | "";
  params?: Record<string, any>;
  data?: Record<string, any>;
}

const initialState: IModal = {
  title: TitleComponents.Customer,
  open: false,
  component: "",
  params: {},
  data: {},
};

// Nota: este store NO se persiste a localStorage a propósito. El estado de
// qué modal está abierto (y sus params, que pueden incluir datos de un
// cliente/orden en curso) es puramente transitorio: si sobrevive a un
// refresh de página, reaparecen modales "fantasma" con datos de una sesión
// anterior (posible fuga de datos de un cliente hacia el siguiente).
export const useModalStore = create<IModal & ModalAction>()(
  devtools((set, get) => ({
    ...initialState,
    closeModal: () => set({ ...initialState }),
    openModal: (componentName?: ComponentModal, data?: Record<string, any>) => {
      if (componentName) {
        set({
          ...get(),
          component: componentName,
          open: true,
          params: data ?? {},
        });
        return;
      }
      set({ ...get(), open: true });
    },
    setTitle: (title: TitleComponents | string) => set({ ...get(), title: title }),
    setComponent: (componentName?: ComponentModal, params?: Record<string, any>) =>
      set({ ...get(), component: componentName, params: params ?? {} }),
  }))
);
